var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.0002H4M4 20.0002H10M4 20.0002V11.4522C4 10.9182 4 10.6512 4.065 10.4022C4.12256 10.1821 4.21725 9.97346 4.345 9.78521C4.49 9.57221 4.691 9.39521 5.093 9.04421L9.894 4.84221C10.64 4.19021 11.013 3.86421 11.432 3.74021C11.802 3.63021 12.197 3.63021 12.567 3.74021C12.987 3.86421 13.361 4.19021 14.107 4.84421L18.907 9.04421C19.309 9.39621 19.51 9.57222 19.655 9.78422C19.782 9.97422 19.877 10.1822 19.935 10.4022C20 10.6512 20 10.9182 20 11.4522V20.0002M10 20.0002H14M10 20.0002V16.0002C10 15.4698 10.2107 14.9611 10.5858 14.586C10.9609 14.2109 11.4696 14.0002 12 14.0002C12.5304 14.0002 13.0391 14.2109 13.4142 14.586C13.7893 14.9611 14 15.4698 14 16.0002V20.0002M20 20.0002H14M20 20.0002H22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.20b36e2cf7e7941b79877ee7ca071340.svg";
export { ForwardRef as ReactComponent };